import {
  StyledBreadcrumbItem,
  StyledBreadcrumbs,
  StyledCurrent,
  StyledLink,
  StyledSeparator,
} from './Breadcrumbs.Styled'

export type BreadcrumbItem = {
  label: string
  href?: string
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <StyledBreadcrumbs aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <StyledBreadcrumbItem key={item.label}>
            {index > 0 && <StyledSeparator>/</StyledSeparator>}
            {isLast || !item.href ? (
              <StyledCurrent>{item.label}</StyledCurrent>
            ) : (
              <StyledLink href={item.href}>{item.label}</StyledLink>
            )}
          </StyledBreadcrumbItem>
        )
      })}
    </StyledBreadcrumbs>
  )
}
